import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './PdfViewerToolbarButton.less';

class PdfViewerToolbarButton extends React.PureComponent {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick(event) {
    const {clickPressCallback, disabled, item} = this.props;
    if (!disabled) {
      event.stopPropagation();
      clickPressCallback(item);
    }
  }

  handleKeyDown(event) {
    const {clickPressCallback, disabled, item} = this.props;
    if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
      event.stopPropagation();
      clickPressCallback(item);
    }
    return true;
  }

  render() {
    const {disabled, iconClass, titleText} = this.props;
    return (
      <i
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        tabIndex={'0'}
        role={'button'}
        title={titleText}
        className={classNames(iconClass, styles.dlPdfViewerToolbarButton, {
          [styles.dlDisabled]: disabled,
        })}
      />
    );
  }
}

PdfViewerToolbarButton.displayName = 'PdfViewerToolbarButton';

PdfViewerToolbarButton.propTypes = {
  clickPressCallback: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  item: PropTypes.objectOf(PropTypes.any),
  titleText: PropTypes.string,
  disabled: PropTypes.bool,
};

PdfViewerToolbarButton.defaultProps = {
  disabled: false,
  item: undefined,
  titleText: '',
};

export default PdfViewerToolbarButton;
